// The assistant's customer model card (plan
// 2026-10-21-customer-data-modeling-platform, P2.9).
//
// On confirm the user's browser saves the draft through the routes the Models
// editor uses, under the user's own JWT: the route decides (account owner or
// admin, the project and model in this account). Saving a draft changes
// nothing in the warehouse; the link opens the model in Models, where the
// person validates and publishes it.
import { createModel, updateModel, type ModelConfig } from "@/api/dataModeling";
import { registerAction } from "./registry";

registerAction("save_data_model_draft", async (params) => {
  const projectId = params.project_id as string;
  const modelId = (params.model_id as string | undefined) ?? null;
  const fields = {
    ...(typeof params.name === "string" ? { name: params.name } : {}),
    ...(typeof params.folder_path === "string" ? { folder_path: params.folder_path } : {}),
    body: params.body as string,
    ...(params.config ? { config: params.config as ModelConfig } : {}),
  };
  const model = modelId
    ? await updateModel(projectId, modelId, fields)
    : await createModel(projectId, { ...fields, name: params.name as string, slug: params.slug as string });
  const query = new URLSearchParams({ project: projectId, model: model.id });
  return {
    resultRef: { project_id: projectId, model_id: model.id },
    link: { label: "Open in Models", to: `/data-management/models?${query.toString()}` },
  };
});
